import classNames from 'classnames';
import { useCrossBrowserContext } from 'hooks/useCrossBrowserContext';
import { FC } from 'react';

import type { ShareButtonProps } from './ShareButton.connect';

export const RawShareButtonNext: FC<ShareButtonProps> = ({ className, onShare, isDisabled }) => {
  const { isDirty, isLocked } = useCrossBrowserContext();
  const isCrossBrowserFrozen = isDirty || isLocked;
  const isShareDisabled = isDisabled || isCrossBrowserFrozen;
  return (
    <button
      data-e2e="open-product-summary"
      type="button"
      className={classNames('btn btn-icon', className)}
      onClick={onShare}
      disabled={isShareDisabled}
    >
      <i className="icon icon-sm">share</i>
    </button>
  );
};

RawShareButtonNext.displayName = 'RawShareButton';
